module.exports = __webpack_public_path__ + "img/gb955.prt.8eb15b80.jpg";